import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { AuthService } from "../services";

// On the default landing, send a signed-in user who has NO feature grants - a brand-new / unassigned
// account, e.g. an auto-provisioned SSO "New Employee" - to the pending-access page instead of an empty
// dashboard. Users with any feature pass through unchanged.
export const PendingRedirectGuard: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> => {

    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);

    return authService.ensureFeaturesLoaded().pipe(
        map(() => authService.hasNoFeatures() ? router.createUrlTree(['/pending-access']) : true)
    );
}
